import { Component, OnInit,AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ViewModeEnum, AlertDialogTypeEnum } from '../../../_enums/_index';
import { UserModel, ServiceTypePermissionModel } from '../../../_models/_index';
import { UserService ,GeneralService} from '../../../services/_index';
import { AlertDialogComponent } from '../../alert-dialog/alert-dialog.component';
import { InfraService } from '../../../services/_index';

@Component({
    selector: 'app-users-dialog',
    templateUrl: './users-dialog.component.html',
    styleUrls: ['./users-dialog.component.css']
})

export class UsersDialogComponent implements OnInit, AfterViewInit {

    dialogHeader: string;
    viewMode: ViewModeEnum;
    user: UserModel = new UserModel();
    serviceTypePermissionList: ServiceTypePermissionModel[];

    constructor(private usersService: UserService,
        private generalService: GeneralService,
        private dialog: MatDialog,
        private infraService: InfraService,
        public dialogRef: MatDialogRef<UsersDialogComponent>) { }

    ngOnInit() {
        this.loadServiceTypePermission();
    }

    ngAfterViewInit() {
        this.usersService.decryptPassword(this.user).then(res =>
        {
            this.user.password = res;
        });
    }

    getSaveText() {
        switch (this.viewMode) {
            case ViewModeEnum.Add:
                return "הוסף";
            case ViewModeEnum.Edit:
                return "עדכן";
        }
    }

    save() {
        if (this.viewMode == ViewModeEnum.Add) {
            this.add();
        }
        else {
            this.edit();
        }
    }

    private validatePassword()
    {
        var regex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}/g;
        let res= regex.test(this.user.password);
        if (!res)
        {
            this.generalService.showErrorDialog("הזן סיסמא בעלת 8 תווים לפחות,אות גדולה,אות קטנה,ספרה ותו מיוחד(@$!*?&)");
            return false;
        }
        return true;
    }

    private add() {
        this.usersService.checkUnique(this.user).then((isUniqe: boolean) => {
            if (isUniqe) {
                if (!this.validatePassword()) {
                    return;
                }
                this.usersService.addUser(this.user).then((result: UserModel) => {
                    if (result) {
                        this.dialogRef.close(result);
                    }
                });
            }
            else {
                this.generalService.showErrorDialog("שם משתמש כבר קיים!");

                
            }
        });
    }

    private edit() {
        this.usersService.checkUnique(this.user).then((isUniqe: boolean) => {
            if (isUniqe) {
                if (!this.validatePassword())
                {
                    return;
                }

                this.usersService.editUser(this.user).then((result: UserModel) => {
                    if (result) {
                        this.dialogRef.close(result);
                    }
                });
            }
            else {
                this.generalService.showErrorDialog("שם משתמש כבר קיים!");
            }
        });
    }

    private isEditMode() {
        return this.viewMode == ViewModeEnum.Edit;
    }

    private loadServiceTypePermission() {
        this.infraService.getServiceTypePermission().then(result => {
            this.serviceTypePermissionList = result;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/users/users-dialog/users-dialog.component.ts